import request from '@/utils/request'
import SERVICE from './enums'

// 登录
export function login(data) {
  return request({
    url: `${SERVICE.API_AUTH}/sysAuth/login`,
    method: 'post',
    data
  })
}

// 注册
export function register(data) {
  return request({
    url: `${SERVICE.API_AUTH}/sysAuth/register`,
    method: 'post',
    data
  })
}

// 登出
export function logout(params) {
  return request({
    url: `/authorityservice/auth/logout`,
    method: 'get',
    params
  })
}

// 修改密码
export function updatePwd(data) {
  return request({
    url: `${SERVICE.API_AUTH}/sysAuth/updatePwd`,
    method: 'post',
    data
  })
}

// 重置密码
export function resetPwd(data) {
  return request({
    url: `${SERVICE.API_AUTH}/sysAuth/resetPwd`,
    method: 'post',
    data
  })
}

// 忘记密码-发邮件
export function forgetPwd(params) {
  return request({
    url: `${SERVICE.API_AUTH}/sysAuth/forgetPwd`,
    method: 'get',
    params
  })
}

// 注销账户
export function logoff() {
  return request({
    url: `${SERVICE.API_AUTH}/sysAuth/logoff`,
    method: 'get',
  })
}

// 更新当前用户信息 
export function updateMe(data) {
  return request({
    url: `${SERVICE.API_AUTH}/sysUser/me/update`,
    method: "post",
    data
  });
}

// 获取当前用户信息 
export function getCurrentUserInfo() {
  return request({
    url: `/authorityservice/user/getCurrentUserInfo`,
    method: "get"
  });
}

// 获取当前用户菜单
export function getResourceTree() {
  return request({
    url: `${SERVICE.API_AUTH}/sysResource/getResourceTree`,
    method: "get"
  });
}

// 获取当前用户菜单
export function getOrgTreeApi() {
  return request({
    url: `${SERVICE.API_AUTH}/sysOrg/getOrgTree`,
    method: "get"
  });
}